import './App.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import QRCode from 'qrcode';
import { Buffer } from 'buffer';
import './wallet-utils.ts';

import {
  Main,
  Pdq,
  Admin,
  System,
  StoreRequest,
  Activate,
  Employees,
  ActivationCopy,
} from "./screens";

// CRITICAL: Set up Buffer global for bitcore libraries (from original working code)
window.Buffer = window.Buffer || Buffer;

class App extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
	    <Router>
	      <Routes>
	        <Route path="/" element={<Main />} />
	        <Route path="/pdq" element={<Pdq />} />
	        <Route path="/admin" element={<Admin />} />
	        <Route path="/system" element={<System />} />
	        <Route path="/request" element={<StoreRequest />} />
	        <Route path="/activate" element={<Activate />} />
	        <Route path="/activate/:token" element={<Activate />} />
	        <Route path="/activation-link/:token" element={<ActivationCopy />} />
	        <Route path="/employees" element={<Employees />} />
	      </Routes>
	    </Router>		
		);
	}
}

export default App;
